import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from './../../../shared/shared.module';

import { InvestmentsExtractComponent } from './investments-extract.component';
import { InvestmentsExtractDetailsComponent } from './investments-extract-details/investments-extract-details.component';
import { HistoryMovementComponent } from './history-movement/history-movement.component';
import { InvestmentsService } from '../investments.service';
import { MatProgressSpinnerModule, MatExpansionModule } from '@angular/material';
import { AppRoutingModule } from '../../../app-routing.module';
import { InvestmentDetailComponent } from './investment-detail/investment-detail.component';


@NgModule({
	imports: [
		AppRoutingModule,
		CommonModule,
		SharedModule,
		MatButtonModule,
		MatInputModule,
		MatProgressBarModule,
		FormsModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule,
		MatExpansionModule
	],
	exports: [
		InvestmentsExtractComponent,
		InvestmentsExtractDetailsComponent
	],
	declarations: [
		InvestmentsExtractComponent,
		InvestmentsExtractDetailsComponent,
		HistoryMovementComponent,
		InvestmentDetailComponent
	],
	providers: [
		InvestmentsService
	]
})
export class InvestmentsExtractModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-extract/investments-extract.module.ts